import { c as _c } from "react/compiler-runtime";
import { CompleteRepaymentPlan } from "@modules/homepage/sections/RepaymentCalculator/calculateRepayment";
import ResultRow from "@modules/homepage/sections/RepaymentCalculator/ResultRow";
import { formatMoney } from "@justhome/common";
import { FC } from "react";
interface RepaymentCalculatorDetailsProps {
  title: string;
  repaymentPlan?: CompleteRepaymentPlan;
}
const formatYear = (year: number | undefined) => {
  if (!year) {
    return "";
  }
  return year > 1 ? `${Math.floor(year)} Jahre` : `${Math.floor(year)} Jahr`;
};
const RepaymentCalculatorDetails: FC<RepaymentCalculatorDetailsProps> = t0 => {
  const $ = _c(54);
  const {
    title,
    repaymentPlan
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <p className="text-app-h2 mb-s">{title}</p>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-app-h3">Erste Finanzierung</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = repaymentPlan?.repayment.monthlyRepayment;
  let t4;
  if ($[3] !== t3) {
    t4 = formatMoney(t3, true, "de");
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <ResultRow label="Monatliche Rate" value={t4} />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = repaymentPlan?.repayment.durationYears;
  let t7;
  if ($[7] !== t6) {
    t7 = formatYear(t6);
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7) {
    t8 = <ResultRow label="Laufzeit" value={t7} />;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = repaymentPlan?.repayment?.interestAmount;
  let t10;
  if ($[11] !== t9) {
    t10 = formatMoney(t9, false, "de");
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10) {
    t11 = <ResultRow label="Zinskosten" value={t10} />;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const t12 = repaymentPlan?.repayment.residualDept;
  let t13;
  if ($[15] !== t12) {
    t13 = formatMoney(t12, false, "de");
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t13) {
    t14 = <ResultRow label="Restschuld" value={t13} />;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t1 || $[20] !== t11 || $[21] !== t14 || $[22] !== t5 || $[23] !== t8) {
    t15 = <div className="space-y-2xs">{t1}{t2}{t5}{t8}{t11}{t14}</div>;
    $[19] = t1;
    $[20] = t11;
    $[21] = t14;
    $[22] = t5;
    $[23] = t8;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== repaymentPlan) {
    t16 = repaymentPlan?.secondaryRepayment?.startDate ? `ab ${repaymentPlan.secondaryRepayment.startDate.getFullYear()}` : "keine";
    $[25] = repaymentPlan;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t16) {
    t17 = <p className="text-app-h3">Anschlussfinanzierung ({t16})</p>;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  const t18 = repaymentPlan?.secondaryRepayment?.monthlyRepayment;
  let t19;
  if ($[29] !== t18) {
    t19 = formatMoney(t18, true, "de");
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t19) {
    t20 = <ResultRow label="Monatliche Rate" value={t19} />;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  const t21 = repaymentPlan?.secondaryRepayment?.durationYears;
  let t22;
  if ($[33] !== t21) {
    t22 = formatYear(t21);
    $[33] = t21;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== t22) {
    t23 = <ResultRow label="Laufzeit" value={t22} />;
    $[35] = t22;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  const t24 = repaymentPlan?.secondaryRepayment?.interestAmount;
  let t25;
  if ($[37] !== t24) {
    t25 = formatMoney(t24, false, "de");
    $[37] = t24;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] !== t25) {
    t26 = <ResultRow label="Zinskosten" value={t25} />;
    $[39] = t25;
    $[40] = t26;
  } else {
    t26 = $[40];
  }
  const t27 = repaymentPlan?.secondaryRepayment?.residualDept;
  let t28;
  if ($[41] !== t27) {
    t28 = formatMoney(t27, false, "de");
    $[41] = t27;
    $[42] = t28;
  } else {
    t28 = $[42];
  }
  let t29;
  if ($[43] !== t28) {
    t29 = <ResultRow label="Restschuld" value={t28} />;
    $[43] = t28;
    $[44] = t29;
  } else {
    t29 = $[44];
  }
  let t30;
  if ($[45] !== t17 || $[46] !== t20 || $[47] !== t23 || $[48] !== t26 || $[49] !== t29) {
    t30 = <div className="space-y-2xs">{t17}{t20}{t23}{t26}{t29}</div>;
    $[45] = t17;
    $[46] = t20;
    $[47] = t23;
    $[48] = t26;
    $[49] = t29;
    $[50] = t30;
  } else {
    t30 = $[50];
  }
  let t31;
  if ($[51] !== t15 || $[52] !== t30) {
    t31 = <div className="flex flex-col mt-m gap-x-xl gap-y-m whitespace-nowrap">{t15}{t30}</div>;
    $[51] = t15;
    $[52] = t30;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  return t31;
};
export default RepaymentCalculatorDetails;